import { render, staticRenderFns } from "./help5.vue?vue&type=template&id=8d41837a&scoped=true"
import script from "./help5.vue?vue&type=script&lang=js"
export * from "./help5.vue?vue&type=script&lang=js"
import style0 from "./help5.vue?vue&type=style&index=0&id=8d41837a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d41837a",
  null
  
)

export default component.exports